export * from "./components/accordion-panel";
export * from "./components/accordion";
export * from "./services/accordion.service";
export * from "./accordion.module";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/accordion/index.js
// module id = 478
// module chunks = 0